import $ from "jquery/dist/jquery";

$(() => {
  function updateCount(wrapper) {
    let count = 0;
    wrapper
      .find("input[type='checkbox'].multi-cart-add-item:checked")
      .each(function () {
        count += parseInt($(this).attr("data-multi-cart-add-count"));
      });

    if (count === 0) {
      wrapper.find(".multi-cart-add-btn").addClass("disabled");
      $(".multi-cart-add-item-count").text("");
    } else {
      wrapper.find(".multi-cart-add-btn").removeClass("disabled");
      $(".multi-cart-add-item-count").text(count);
    }
  }

  $(".multi-cart-add-item").on("change", function () {
    const wrapper = $(this).closest(".multi-cart-add-wrapper");
    updateCount(wrapper);
  });

  $(".multi-cart-add-wrapper").each(function () {
    updateCount($(this));
  });

  $(".multi-cart-add-btn").on("click", function (e) {
    const wrapper = $(this).closest(".multi-cart-add-wrapper");
    const btn = $(this);
    e.preventDefault();

    let toAdd = [];
    wrapper
      .find("input[type='checkbox'].multi-cart-add-item:checked")
      .each(function () {
        toAdd.push({
          itemId: parseInt($(this).attr("data-multi-cart-add-item")),
          quantity: parseInt($(this).attr("data-multi-cart-add-count")),
          addonIds: [],
        });
      });

    $.ajax({
      url: window.NXURLS.URL_ESHOP_ADD_TO_CART,
      method: "POST",
      contentType: "application/json",
      data: JSON.stringify({
        addToCart: toAdd,
      }),
    })
      .done((data) => {
        $(document).trigger("eshop:item-add", [data.gtmJSONs]);
        if (btn.hasClass("no-eshop-modal")) {
          $(document).trigger("eshop:add", [
            data,
            false,
            btn.hasClass("eshop-refresh-page"),
          ]);
        } else {
          $(document).trigger("eshop:add", data);
        }
        wrapper
          .find("input[type='checkbox'].multi-cart-add-item:checked")
          .prop("checked", false);
      })
      .fail(() => {
        window.NXCMS.toast("Nepovedlo se přidat!", 4000);
      });
  });
});
